import { render, staticRenderFns } from "./AnnualReport.vue?vue&type=template&id=dbbcc5a6"
import script from "./AnnualReport.vue?vue&type=script&lang=js"
export * from "./AnnualReport.vue?vue&type=script&lang=js"
import style0 from "./AnnualReport.vue?vue&type=style&index=0&id=dbbcc5a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports